/* unplugin-vue-components disabled */import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "detail_container__gKAcX"
};
var _hoisted_2 = {
  "class": "ant-breadcrumb detail_breadcrumb__hZzd3"
};
var _hoisted_3 = ["textContent"];
var _hoisted_4 = {
  "class": "detail_postWrapper__6j9wr"
};
var _hoisted_5 = {
  style: {
    "width": "calc(100% - 345px)"
  }
};
var _hoisted_6 = {
  "class": "detail_post__5EZ_P"
};
var _hoisted_7 = {
  "class": "detail_entryMain__H5HyW"
};
var _hoisted_8 = {
  "class": "detail_entryHead___xicO"
};
var _hoisted_9 = ["textContent"];
var _hoisted_10 = {
  "class": "detail_entryInfo__8TF0T"
};
var _hoisted_11 = ["datetime", "textContent"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = {
  "class": "detail_sidebar__SMc_H"
};
var _hoisted_14 = {
  "class": "detail_widget__8Hmp0 detail_widget_recent__T_11i"
};
var _hoisted_15 = {
  "class": "list"
};
var _hoisted_16 = ["onClick", "textContent"];
import { newsApi, newsListApi } from '@/api/activi/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'NewDetails',
  setup: function setup(__props) {
    var newsData = ref([{
      id: '',
      name: '',
      context: '',
      createTime: '',
      image: ''
    }]);
    var newParam = ref({
      pageNum: 1,
      pageSize: 10,
      type: 0,
      hotspot: ''
    });
    function getNewsList() {
      return _getNewsList.apply(this, arguments);
    }
    function _getNewsList() {
      _getNewsList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res$data$records, _res$data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return newsListApi(newParam.value);
            case 2:
              res = _context2.sent;
              if (res.code == 200) {
                newsData.value = (_res$data$records = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.records) !== null && _res$data$records !== void 0 ? _res$data$records : [];
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _getNewsList.apply(this, arguments);
    }
    var activiModel = ref();
    var route = useRoute();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getNewsOne(route.params.id);
            getNewsList();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    function getNewsOne(_x) {
      return _getNewsOne.apply(this, arguments);
    }
    function _getNewsOne() {
      _getNewsOne = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(id) {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return newsApi(id);
            case 2:
              res = _context3.sent;
              if (res.code === 200) {
                activiModel.value = res.data;
              } else {
                ElMessage.error(res.msg);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _getNewsOne.apply(this, arguments);
    }
    function clickItem(id) {
      getNewsOne(id);
    }
    return function (_ctx, _cache) {
      var _unref2, _unref3, _unref4, _unref5, _unref6;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [_createElementVNode("ol", null, [_cache[0] || (_cache[0] = _createElementVNode("li", null, [_createElementVNode("a", {
        "class": "ant-breadcrumb-link",
        href: "/"
      }, "首页"), _createElementVNode("span", {
        "class": "ant-breadcrumb-separator"
      }, ">")], -1)), _createElementVNode("li", null, [_createElementVNode("span", {
        "class": "ant-breadcrumb-link",
        textContent: _toDisplayString((_unref2 = _unref(activiModel)) === null || _unref2 === void 0 ? void 0 : _unref2.name)
      }, null, 8, _hoisted_3)])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("article", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h1", {
        "class": "detail_entryTitle__Jh4CR",
        textContent: _toDisplayString((_unref3 = _unref(activiModel)) === null || _unref3 === void 0 ? void 0 : _unref3.name)
      }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1)), _cache[2] || (_cache[2] = _createElementVNode("span", {
        "class": "detail_dot__izADT"
      }, "•", -1)), _createElementVNode("time", {
        datetime: (_unref4 = _unref(activiModel)) === null || _unref4 === void 0 ? void 0 : _unref4.createTime,
        textContent: _toDisplayString((_unref5 = _unref(activiModel)) === null || _unref5 === void 0 ? void 0 : _unref5.createTime)
      }, null, 8, _hoisted_11), _cache[3] || (_cache[3] = _createElementVNode("span", {
        "class": "detail_dot__izADT"
      }, "•", -1))])]), _createElementVNode("div", {
        "class": "detail_entryContent__4WAq_",
        innerHTML: (_unref6 = _unref(activiModel)) === null || _unref6 === void 0 ? void 0 : _unref6.context
      }, null, 8, _hoisted_12)])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[4] || (_cache[4] = _createElementVNode("h3", {
        "class": "detail_reportListTitle__266h_"
      }, "最新活动", -1)), _createElementVNode("ul", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsData), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.id
        }, [_createElementVNode("a", {
          rel: "",
          onClick: function onClick($event) {
            return clickItem(item.id);
          },
          "class": "aaa",
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_16)]);
      }), 128))])])])])]);
    };
  }
});